import { resolveUrl } from "../../../../utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export interface PlaceOrderForm {
  poNumber: string;
  orderInstruction: string;
  deliveryMethod: string;
  isCustomerInitiatedQuote: boolean;
  email: string;
  firstName: string;
  lastName: string;
  plant: string;
  timeZone: string;
  language: string;
  country: string;
  hasPMA: boolean;
  optime: boolean;
  unloadingPoint: string;
  paymentType: string;
  creditCardID: string;
  freightPaymentCode: string;
  freightPaymentAccountNumber: string;
  orderType: string;
}

export enum ErrorCode {
  Generic = "error.generic",
  CreditCard = "error.creditCard",
  SaleStock = "error.saleStock",
}

interface Response {
  success: boolean;
  errorCode?: ErrorCode;
  orderCode?: string;
}

const url = resolveUrl("/checkout/multi/summary/placeOrder");
export function apiSubmitPlaceOrder(form: PlaceOrderForm) {
  // @ts-ignore
  return fetch(url, {
    body: JSON.stringify(form),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => response.json() as Promise<Response>);
}
